<template>
    <div class="card">
        <a
            v-if="link"
            class="title link"
            rel="noopener noreferrer"
            target="_blank"
            :href="link"
        >
            {{ title }}
        </a>

        <div v-else class="title" :href="link">
            {{ title }}
        </div>

        <div v-if="isTwoColumn" class="columns">
            <div class="descriptionColumn description">
                <slot name="description"></slot>
            </div>
            <div class="visualColumn">
                <slot name="visual"></slot>
            </div>
        </div>

        <div v-else class="description">
            <slot name="description"></slot>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
    props: { title: String, link: String },
    setup(props, { slots }) {
        const isTwoColumn = computed(() => slots.visual !== undefined);

        return { isTwoColumn };
    },
});
</script>

<style lang="scss">
@use "@/assets/global";

.card {
    .title {
        color: global.$bold-text-color;
        @media (prefers-color-scheme: dark) {
            color: global.$dark-theme-bold-text-color;
        }
        font-size: 2rem;
    }

    .columns {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap-reverse;
        justify-content: flex-start;
    }

    .descriptionColumn {
        @media all and (max-width: global.$mobile-width) {
            width: 100%;
        }

        @media not all and (max-width: global.$mobile-width) {
            width: 70%;
        }
    }

    .visualColumn {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;

        @media all and (max-width: global.$mobile-width) {
            width: 100%;
        }

        @media not all and (max-width: global.$mobile-width) {
            margin-left: 20px;
            width: calc(30% - 20px);
        }
    }

    .description {
        margin-top: 20px;

        @media not all and (max-width: global.$mobile-width) {
            text-align: justify;
        }
    }
}
</style>
